(function () {
    'use strict';

    angular.module('app')
        .factory('Charts', Charts);

    /* @ngInject */
    function Charts() {

        // Checks for a data point set to "-"
        function hasData(data) {

            if (!angular.isArray(data)) { // shouldn't happen
                return true;
            }

            if (data.length === 0) {
                return false;
            }

            if (!angular.isObject(data[0])) { // shouldn't happen
                return false;
            }

            // Check all categories for data
            for (var i = 0; i < data.length; i++) {

                if (data[i].value !== undefined) {
                    var value = data[i].value;
                    if (!angular.isString(value) || value.trim() !== '-') {
                        return true;
                    }
                } else if (data[i].AdditionalData !== undefined) {
                    var keys = Object.keys(data[i].AdditionalData);
                    for (var j = 0; j < keys.length; j++) {
                        var key = keys[j];
                        var val = data[i][key];
                        if (!angular.isString(val) || val.trim() !== '-') {
                            return true;
                        }
                    }
                } else {
                    console.log('Unexpected data layout in chart factory')
                }
            }

            return false;
        }

        return {
            hasData: hasData
        }
    }
})();
